module.exports = "https://bin.bnbstatic.com/_next/static/images/announcements-d349c413f78d5dc70af48900bf68bce5.png";